import { render } from "./Variation_Periods.vue?vue&type=template&id=54aa7d5e"
import script from "./Variation_Periods.vue?vue&type=script&lang=js"
export * from "./Variation_Periods.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__